import axios from "axios"

export default {

    // ─── Crop Variety (db.Crop) ───────────────────────────────────────────────

    async getCropVarieties({ page = 1, limit = 10, search = '', cropTypeOptId = null } = {}) {
        try {
            const params = { page, limit };
            if (search)        params.search        = search;
            if (cropTypeOptId) params.cropTypeOptId = cropTypeOptId;
            const { data } = await axios.get('/crop-settings/variety', { params });
            return Promise.resolve(data);
        } catch (err) {
            return Promise.reject(err.response);
        }
    },

    async getCropVarietyById(id) {
        try {
            const { data } = await axios.get(`/crop-settings/variety/${id}`);
            return Promise.resolve(data);
        } catch (err) {
            return Promise.reject(err.response);
        }
    },

    async getCropTypeOptions() {
        try {
            const { data } = await axios.get('/crop-settings/variety/options/crop-types');
            return Promise.resolve(data);
        } catch (err) {
            return Promise.reject(err.response);
        }
    },

    async createCropVariety({ name, cropTypeOptId, countryId = null }) {
        try {
            const { data } = await axios.post('/crop-settings/variety', { name, cropTypeOptId, countryId });
            return Promise.resolve(data);
        } catch (err) {
            return Promise.reject(err.response);
        }
    },

    async updateCropVariety(id, { name, cropTypeOptId, countryId } = {}) {
        try {
            const { data } = await axios.put(`/crop-settings/variety/${id}`, { name, cropTypeOptId, countryId });
            return Promise.resolve(data);
        } catch (err) {
            return Promise.reject(err.response);
        }
    },

    async deleteCropVariety(id) {
        try {
            const { data } = await axios.delete(`/crop-settings/variety/${id}`);
            return Promise.resolve(data);
        } catch (err) {
            return Promise.reject(err.response);
        }
    },

}
